import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const TextGenerateEffect = ({ text, onComplete }) => {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex <= text.length) {
        setDisplayText(text.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(interval);
        if (onComplete) onComplete();
      }
    }, 15); // Adjust speed here (lower = faster)

    return () => clearInterval(interval);
  }, [text, onComplete]);

  return (
    <Typography
      sx={{
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 18,
        lineHeight: 1.71,
        color: "#41444B",
      }}
    >
      {displayText}
    </Typography>
  );
};

export default TextGenerateEffect;
